import firebase from 'firebase/app'
import { setSignUp, setSignIn, getUserWsList, getUserToken, getWsClipCnt } from '@/services/api'
import { chkMtPublic } from '@/services/meetingApi'
import { chkChPublic } from '@/services/channelApi'
import router from '../router'
import { sendMessageToExtensionToSignOut } from '@/services/extension.js'

// async function sendMessageToExtensionToSignOut() {
//   const extensionID = 'cooadaolpinhaghnkkimdadhahbjjocb'

//   try {
//     chrome.runtime.sendMessage(extensionID, { type: 'tapeSingOut' }, (response) => {
//       // console.log(response)
//     })
//   } catch (error) {
//     //handle error silently
//   }
// }

const auth = {
  state: () => ({
    currentUser: null,
    userInfo: null,
    currentMt: null,
    userWsList: [],
    selectedWsInfo: null, // TODO: 개선 필요
    chkMtPublic: {
      isPublic: false,
      mtCreatedUid: null,
    },
    chkChPublic: false,
    drawer: true,
    isJoinOrCreate: null, // 로그인 한 상태에서 join or create
    signInRedirectUrl: null, // 로그인 후 이동할 url
    userToken: null,
    // 유저당 현재 워크스페이스의 클립 업로드 갯수를 저장
    wsClipCnt: {
      wsClipDuration: 0,
      freePlanWsClipDurationLimit: 60 * 180,
      planType: 'Free',
      isWsMember: false,
    },
  }),
  mutations: {
    setUserToken(state, userToken) {
      state.userToken = userToken
    },
    // firebase user 정보 설정
    setCurrentUser(state, currentUser) {
      state.currentUser = currentUser
    },
    setCurrentMt(state, currentMt) {
      state.currentMt = currentMt
    },
    setDrawer(state, val) {
      state.drawer = val
    },
    // db user 정보 설정
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
      firebase.analytics().setUserId(userInfo && userInfo.userId ? userInfo.userId : null)
    },
    // 참여 워크스페이스 설정
    setUserWsList(state, userWsList) {
      state.userWsList = userWsList
    },
    // 선택 워크스페이스 정보 설정 // TODO: 개선 필요
    setSelectedWsInfo(state, selectedWsInfo) {
      state.selectedWsInfo = selectedWsInfo
    },
    // 선택 워크스페이스 정보 설정 // TODO: 개선 필요
    chkMtPublic(state, chkMtPublic) {
      state.chkMtPublic = chkMtPublic
    },
    chkChPublic(state, chkChPublic) {
      state.chkChPublic = chkChPublic
    },
    setIsJoinOrCreate(state, isJoinOrCreate) {
      state.isJoinOrCreate = isJoinOrCreate
    },
    setSignInRedirectUrl(state, signInRedirectUrl) {
      state.signInRedirectUrl = signInRedirectUrl
    },
    setWsClipCnt(state, wsClipCnt) {
      state.wsClipCnt = wsClipCnt
    },
  },
  actions: {
    setCurrentMt({ commit }, currentMt) {
      commit('setCurrentMt', currentMt)
    },
    setDrawer({ commit }, val) {
      commit('setDrawer', val)
    },
    // firebase user 정보 설정
    setCurrentUser({ commit }, currentUser) {
      // console.log('setCurrentUser')
      commit('setCurrentUser', currentUser)
    },
    setIsJoinOrCreate({ commit }, isJoinOrCreate) {
      commit('setIsJoinOrCreate', isJoinOrCreate)
    },
    // 회원 가입 처리 후 db user 정보 로드 및 설정
    async setSignUp({ commit }, userInfo) {
      try {
        let result = await setSignUp(
          this._vm,
          userInfo.userFullName,
          userInfo.userDisplayName,
          userInfo.deviceToken,
          userInfo.userStatus,
          userInfo.userEmail
        )
        commit('setUserInfo', result)
        // window.Intercom('boot', {
        //   api_base: 'https://api-iam.intercom.io',
        //   app_id: 'cwldvp80',
        //   email: result.userEmail,
        //   user_id: result.userId,
        //   name: result.userDisplayName || result.userFullName,
        //   userStatus: result.userStatus,
        //   created_at:
        //     result.signedUpAt !== undefined && result.signedUpAt !== null && result.signedUpAt >= 0
        //       ? Math.round(result.signedUpAt / 1000)
        //       : 0,
        //   // custom_launcher_selector: '#my_custom_link',
        // })
      } catch (error) {
        // console.log(error.response.status, error.response.data)
      }
    },
    // 로그인 처리 후 db user 정보 로드 및 설정
    async setSignIn({ commit, dispatch }, signInInfo) {
      try {
        let result = await setSignIn(this._vm, signInInfo.deviceToken, signInInfo.isLinkWithSignin)
        dispatch('setFirebaseLog', {
          eventName: 'current_signin',
          eventParam: {
            name: 'current_signin',
            methodType: 'normal',
          },
        })
        commit('setUserInfo', result)
        // window.Intercom('boot', {
        //   api_base: 'https://api-iam.intercom.io',
        //   app_id: 'cwldvp80',
        //   email: result.userEmail,
        //   user_id: result.userId,
        //   name: result.userDisplayName || result.userFullName,
        //   userStatus: result.userStatus,
        //   created_at:
        //     result.signedUpAt !== undefined && result.signedUpAt !== null && result.signedUpAt >= 0
        //       ? Math.round(result.signedUpAt / 1000)
        //       : 0,
        //   // custom_launcher_selector: '#my_custom_link',
        // })
      } catch (error) {
        // console.log(error.response.status, error.response.data)
        // if (error && error.response && error.response.data === 'userNotExist') {
        // firebase에서 정상적으로 로그인 되었지만 DB에 유저 정보가 없을 경우,
        // 회원가입이 완료되지 않은 것으로 간주하여 가입 처리
        // console.log('state.currentUser   ?   ', state.currentUser)
        // await dispatch('setSignUp', {
        //   userFullName: state.currentUser.fullName,
        //   userDisplayName: state.currentUser.displayName,
        //   deviceToken: deviceToken,
        // })
        // } else {
        // TODO: 번역
        // alert('Sign-in failed')
        // console.log('error.response.data ', error.response.data)
        if (error && error.response && error.response.data === 'userNotExist') {
          dispatch('setSignOut')
          return error.response.data
        } else {
          dispatch('setSignOut')
        }
        // }
      }
    },
    // 로그아웃 처리
    async setSignOut({ state, commit, dispatch }) {
      sendMessageToExtensionToSignOut()
      // window.Intercom('shutdown')
      // window.Intercom('boot', { app_id: 'cwldvp80' })

      await firebase.auth().signOut()
      commit('setCurrentUser', null)
      dispatch('setApiHeader')
      commit('setUserInfo', null)
      commit('setUserWsList', null)
      commit('setSelectedWsInfo', null) // TODO: 개선 필요
      // 초기값으로 세팅
      commit('setWsClipCnt', {
        wsClipDuration: 0,
        freePlanWsClipDurationLimit: 60 * 180,
        planType: 'Free',
        isWsMember: false,
      })
      localStorage.clear()
      if (!state.chkMtPublic['isPublic']) router.replace({ name: 'SignIn' }).catch(() => {})
    },
    // 유저토큰 호출
    async getUserToken({ commit }, userId) {
      let result = await getUserToken(this._vm, userId)
      if (result) commit('setUserToken', result['token'])
      // commit('setUserWsList', result)
    },
    // 참여 워크스페이스 로드
    async getUserWsList({ commit }) {
      let result = await getUserWsList(this._vm)
      commit('setUserWsList', result)
    },
    // 선택 워크스페이스 정보 설정 // TODO: 개선 필요
    async setSelectedWsInfo({ commit }, selectedWsInfo) {
      // console.log('setSelectedWsInfo')
      commit('setSelectedWsInfo', selectedWsInfo)

      // 설정 후 selectedWsInfo가 존재하면
      if (selectedWsInfo !== null) {
        // 채널 로드
        this.dispatch('getChannelList', {
          wsId: selectedWsInfo['wsId'],
          routeParams: selectedWsInfo['routeParams'],
        })
        // 인박스 카운트 호출
        this.dispatch('getAssignedCnt', selectedWsInfo['wsId'])
      }
    },
    // Public Url일 경우 확인
    async chkMtPublic({ commit }, mtId) {
      try {
        let result = await chkMtPublic(this._vm, mtId)
        // console.log('chkMtPublic result', result)
        commit('chkMtPublic', result)
        // commit('setIsPublic', result)
      } catch (error) {
        console.log(error.response.status, error.response.data)
      }
    },
    async chkChPublic({ commit }, params) {
      try {
        let result = await chkChPublic(this._vm, params['wsDomain'], params['chId'])
        commit('chkChPublic', result)
      } catch (error) {
        console.log('chkChPublic error : ', error)
      }
    },
    setSignInRedirectUrl({ commit }, signInRedirectUrl) {
      commit('setSignInRedirectUrl', signInRedirectUrl)
    },
    setFirebaseLog({ state }, params) {
      try {
        if (state.userInfo !== undefined && state.userInfo !== null) {
          firebase.analytics().setUserId(state.userInfo.userId ?? null)
          params['eventParam']['uid'] = state.userInfo['userId']
          params['eventParam']['userName'] = state.userInfo['userDisplayName'] || state.userInfo['userFullName']
          params['eventParam']['userStatus'] = state.userInfo['userStatus']
          params['eventParam']['funnel'] = state.userInfo['funnel']
          params['eventParam']['userAgent'] = state.userInfo['userAgent']
          params['eventParam']['signedUpAt'] = state.userInfo['signedUpAt']
          params['eventParam']['lastSignedInAt'] = state.userInfo['lastSignedInAt']
          params['eventParam']['currentSignedInAt'] = state.userInfo['currentSignedInAt']
          params['eventParam']['funnelUpdatedAt'] = state.userInfo['funnelUpdatedAt']
        }
      } catch (error) {
        console.log('Log event error : ', error)
      }
      firebase.analytics().logEvent(params['eventName'], params['eventParam'])
    },
    async setWsClipCnt({ commit }, params) {
      try {
        if (params && params['wsDomain'] && params['userId']) {
          let result = await getWsClipCnt(this._vm, params['wsDomain'], params['userId'])
          // console.log('result ', result)
          commit('setWsClipCnt', result)
        } else commit('setWsClipCnt', null)
      } catch (error) {
        console.log('wsClipCnt error : ', error)
      }
    },
  },
  getters: {
    userToken(state) {
      return state.userToken
    },
    drawer(state) {
      return state.drawer
    },
    // firebase user 정보
    currentUser(state) {
      return state.currentUser
    },
    currentMt(state) {
      return state.currentMt
    },
    // db user 정보
    userInfo(state) {
      return state.userInfo
    },
    // 참여 워크스페이스 리스트
    userWsList(state) {
      return state.userWsList
    },
    // 워크스페이스 정보 // TODO: 개선 필요
    selectedWsInfo(state) {
      return state.selectedWsInfo
    },
    // db user 정보
    userName(state) {
      return state.userInfo && state.userInfo.userDisplayName
        ? state.userInfo.userDisplayName
        : state.userInfo && state.userInfo.userFullName
        ? state.userInfo.userFullName
        : ''
    },
    chkMtPublic(state) {
      return state.chkMtPublic
    },
    chkChPublic(state) {
      return state.chkChPublic
    },
    isJoinOrCreate(state) {
      return state.isJoinOrCreate
    },
    signInRedirectUrl(state) {
      return state.signInRedirectUrl
    },
    isMtOrganizer(state) {
      let userId = state.userInfo && state.userInfo !== null ? state.userInfo.userId : ''
      let mtOrganizerUid = state.currentMt && state.currentMt !== null ? state.currentMt.mtOrganizerUid : ''
      return userId !== '' && mtOrganizerUid !== '' && userId === mtOrganizerUid
    },
    isMtCreator(state) {
      let userId = state.userInfo && state.userInfo !== null ? state.userInfo.userId : ''
      let mtCreatedUid = state.currentMt && state.currentMt !== null ? state.currentMt['mtCreatedUid'] : ''
      return userId !== '' && mtCreatedUid !== '' && userId === mtCreatedUid
    },
    isWsOwner(state) {
      let userId = state.userInfo && state.userInfo !== null ? state.userInfo.userId : ''
      let wsOwnerId = state.selectedWsInfo && state.selectedWsInfo !== null ? state.selectedWsInfo.wsCreatedUid : ''
      return userId !== '' && wsOwnerId !== '' && userId === wsOwnerId
    },
    isWsManager(state) {
      return (
        state.selectedWsInfo && state.selectedWsInfo['memberType'] && state.selectedWsInfo['memberType'] === 'manager'
      )
    },
    wsClipCnt(state) {
      return state.wsClipCnt
    },
    // isShowFollowUp(state) {
    //   let returnValue = false
    //   let isPrivate =
    //     state.currentMt !== undefined && state.currentMt !== null && state.currentMt.mtPermission === 'private'

    //   // 로그인이 되어있고 private 미팅이 아니고, Workspace 멤버인 경우 경우
    //   if (
    //     state.userInfo !== undefined &&
    //     state.userInfo !== null &&
    //     state.selectedWsInfo !== undefined &&
    //     state.selectedWsInfo !== null &&
    //     !isPrivate
    //   ) {
    //     // 미팅이 public 일 경우
    //     if (state.currentMt.isPublic) {
    //       // Meeting Organizer 또는 자신이 속한 워크스페이스인 미팅일 경우는 보여준다.
    //       if (
    //         state.currentMt.mtOrganizerUid === state.userInfo.userId ||
    //         state.selectedWsInfo.wsId === state.currentMt.wsId
    //       ) {
    //         returnValue = true
    //       } else {
    //         // 내가 속한 워크스페이스의 미팅인지 확인
    //         // Attendee List 확인은 추후에 ..
    //         // let attendeeList = state.currentMt.mtAttendeeList
    //         // console.log('attendeeList   ', attendeeList)
    //         // if (attendeeList !== undefined && attendeeList !== null && attendeeList.length > 0) {
    //         //   let index = attendeeList.findIndex((attendee) => attendee.userId === state.userInfo.userId)
    //         //   if (index >= 0) returnValue = true
    //         // }
    //       }
    //     } else {
    //       returnValue = true
    //     }
    //   }
    //   return returnValue
    // },
  },
}

export default auth
